import React from 'react';
import { Typography } from '../Typography/Typography';
import classNames from 'classnames/bind';
import styles from './Chip.module.scss';

const cx = classNames.bind(styles);

export interface IChipProps {
  label: string;
  backgroundColor: 'aubergine' | 'kale';
}

const Chip = ({ label, backgroundColor }: IChipProps) => {
  return (
    <div
      className={cx('chip', {
        [`chip-${backgroundColor}`]: backgroundColor,
      })}
    >
      <Typography color="secondary">{label}</Typography>
    </div>
  );
};

export default Chip;
